export const EMPTY_PLACE_HOLDER = '--'
export const menus = [
  {
    name: '首页',
    url: '/'
  }
  // ,
  // {
  //   name: '功能说明',
  //   url: '/'
  // },
  // {
  //   name: '关于我们',
  //   url: '/'
  // },
  // {
  //   name: '联系我们',
  //   url: '/'
  // }
]

export const userMenus = [
  // {
  //   name: '首页',
  //   url: '/'
  // },
  // {
  //   name: '关注',
  //   url: '/'
  // },
  // {
  //   name: '推荐',
  //   url: '/'
  // },
  // {
  //   name: '期刊',
  //   url: '/journal/list'
  // }
  // {
  //   name: '自然地理',
  //   url: '/'
  // },
  // {
  //   name: '经济地理',
  //   url: '/'
  // },
  // {
  //   name: '人文地理',
  //   url: '/'
  // }
]

export const INDEX_LIST_TYPE_ARTICLE = 1
export const INDEX_LIST_TYPE_SPECIAL_SUBJECT = 2

// 订阅枚举：学者1，期刊2
export const SUBSCRIBE_TYPE_SCHOLAR = 1
export const SUBSCRIBE_TYPE_JOURNAL = 2

// 搜索枚举：学者1，关键词2，基金3
export const SEARCH_TYPE_SCHOLAR = 1
export const SEARCH_TYPE_KEYWORD = 2
export const SEARCH_TYPE_FUND = 3
